export const environment = {
  "production": true,
  "github": {
    "api": "https://api.github.com",
    "token": "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",
    "username": "abelgasque"
  },
  "firebase": {
    "apiKey": "AIzaSyDzl4hqLzEXDxtmJ5bhPv0mQ04xM0sEeLY",
    "authDomain": "cv-abelgasque-8b898.firebaseapp.com",
    "databaseURL": "https://cv-abelgasque-8b898.firebaseio.com",
    "projectId": "cv-abelgasque-8b898",
    "storageBucket": "cv-abelgasque-8b898.firebasestorage.app",
    "messagingSenderId": "737819341027",
    "appId": "1:737819341027:web:7ac305e822e0b56f0515d6",
    "measurementId": "G-28597K9Y22"
  }
};
